import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import Button from "../../../../Common/Button/Button";
import { DynamicContext } from "../../../../Context/DynamicContext";
import {
  VYLABS_BASE_URL,
  LIST_MEMEBERS_OF_TENANT,
} from "../../../../helper/url_helper";
import { get } from "../../../../helper/Api_helper";
import { TENANT_CORE_API_KEY } from "../../../../Tenant-Config/TenantConfig";
import { useFormik } from "formik";
import moment from "moment";
import StagePopupIcon from "../../../../Assets/Images/stagepop-close-icon.svg";
import trackedNotSelectedIcon from "../../../../Assets/Images/tracked-not-selected-icon.svg";
import trackedSelectedIcon from "../../../../Assets/Images/tracked-selected-icon.svg";
import createdDarkIcon from "../../../../Assets/Images/Created-Tracked-Candidates-A-Dark.svg";
import createdNotSelectDark from "../../../../Assets/Images/Created-Tracked-Candidates-NA-Dark.svg";
import "../../../../Common/StageFilterPopup/StageFilterPopup.css";
import calendarIcon from "../../../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../../../Assets/Images/calendar-dark-Icon.png";
import { CustomDatePickerModal } from "../../../../Common/Date-Picker/DatePicker";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar";

function ClientFilters({
  isOpen,
  onClose,
  onApply,
  initialUserId,
  initialIsTracked,
  initialIsCreated,
  initialFromDate,
  initialEndDate,
  setActiveClientFilterType,
  setActiveClientFilterUserId,
}) {
  const { userDetails, isDarkMode, AdminAccess,isHiringTeamTenant } = useContext(DynamicContext);
const tenantLabel = isHiringTeamTenant ? "Hiring Team" : "Client";
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isUsersLoading, setIsUsersLoading] = useState(false);
  const [tempFromDate, setTempFromDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [openPicker, setOpenPicker] = useState(null);
  const [pickerPosition, setPickerPosition] = useState({
    top: null,
    left: null,
  });
  const fromRef = useRef(null);
  const endRef = useRef(null);
  const isFetching = useRef(false);

  const formik = useFormik({
    initialValues: {
      users: initialUserId || "",
    },
    enableReinitialize: true,
  });

  const [tempIsTrackedByMeActive, setTempIsTrackedByMeActive] = useState(false);
  const [tempIsCreatedByMeActive, setTempIsCreatedByMeActive] = useState(false);
  const fetchUsers = useCallback(async () => {
    if (isFetching.current || !AdminAccess) return;

    isFetching.current = true;
    setIsUsersLoading(true);
    try {
      const allUsers = [];
      let offset = 0;
      let hasMore = true;
      const limit = 50;
      const requestConfig = {
        headers: { "X-API-Key": TENANT_CORE_API_KEY },
      };

      while (hasMore) {
        const response = await get(
          VYLABS_BASE_URL,
          `${LIST_MEMEBERS_OF_TENANT}?tenant_id=${userDetails?.tenant_id}&offset=${offset}&limit=${limit}`,
          requestConfig,
        );
        const fetched = response?.users || [];
        allUsers.push(...fetched);
        if (fetched.length < limit) {
          hasMore = false;
        } else {
          offset += limit;
        }
      }

      const options = allUsers.map((u) => ({
        label:
          `${u?.user?.first_name || ""} ${u?.user?.last_name || ""}`.trim(),
        value: u?.user?.id,
      }));

      const uniqueOptions = (options || [])
        .filter((o) => o?.value)
        .filter(
          (item, index, self) =>
            index === self.findIndex((x) => x.value === item.value),
        );

      const meId = userDetails?.id;
      const optionsWithMePinned = meId
        ? [
            { label: "Me", value: meId },
            ...uniqueOptions.filter((o) => String(o.value) !== String(meId)),
          ]
        : uniqueOptions;

      setUsers(optionsWithMePinned);
      setFilteredUsers(optionsWithMePinned);
    } catch (error) {
      console.error("error fetching members", error);
    } finally {
      setIsUsersLoading(false);
      isFetching.current = false;
    }
  }, [userDetails?.tenant_id, userDetails?.role, userDetails?.id]);

  const getInitialDate = useCallback((date) => {
    if (!date) return null;
    const parsedDate = moment(date, "YYYY-MM-DD", true);
    return parsedDate.isValid() ? parsedDate.toDate() : null;
  }, []);

  const openDatePicker = (pickerType, ref) => {
    const rect = ref.current.getBoundingClientRect();
    setPickerPosition({
      top: rect.bottom + 5,
      left: rect.left,
    });
    requestAnimationFrame(() => {
      setOpenPicker(pickerType);
    });
  };

  useEffect(() => {
    if (isOpen) {
      const noFilterActive = !initialIsTracked && !initialIsCreated;
      setTempIsTrackedByMeActive(initialIsTracked || noFilterActive);
      setTempIsCreatedByMeActive(initialIsCreated || false);
      setTempFromDate(getInitialDate(initialFromDate));
      setTempEndDate(getInitialDate(initialEndDate));
      if (AdminAccess && users.length === 0) {
        fetchUsers();
      }
    }
  }, [
    isOpen,
    userDetails?.role,
    fetchUsers,
    users.length,
    initialIsTracked,
    initialIsCreated,
    initialFromDate,
    initialEndDate,
    getInitialDate,
  ]);

  useEffect(() => {
  if (!isOpen) {
    setOpenPicker(null);
    setPickerPosition({
      top: null,
      left: null,
    });
  }
}, [isOpen]);

  const handleTrackedByMeClick = () => {
    setTempIsTrackedByMeActive((prev) => !prev);
    setTempIsCreatedByMeActive(false);
  };

  const handleCreatedByMeClick = () => {
    setTempIsCreatedByMeActive((prev) => !prev);
    setTempIsTrackedByMeActive(false);
  };

  const handleApply = () => {
    if ((tempFromDate && !tempEndDate) || (!tempFromDate && tempEndDate)) {
      Toast("error", "Please select both 'From date' and 'End date'.");
      return;
    }

    const selectedUserValue = formik.values.users;
    const selectedUserData = users.find((u) => u.value === selectedUserValue);
    onApply({
      userId: selectedUserValue,
      label: selectedUserData ? selectedUserData.label : "",
      isTrackedByMeActive: tempIsTrackedByMeActive,
      isCreatedByMeActive: tempIsCreatedByMeActive,
      fromDate: tempFromDate ? moment(tempFromDate).format("YYYY-MM-DD") : "",
      endDate: tempEndDate ? moment(tempEndDate).format("YYYY-MM-DD") : "",
    });
  };

  const handleClear = () => {
    setTempIsTrackedByMeActive(true);
    setTempIsCreatedByMeActive(false);
    setTempFromDate(null);
    setTempEndDate(null);
    formik.setFieldValue("users", "");
    setActiveClientFilterType("");
    setActiveClientFilterUserId("");
    onApply({
      userId: "",
      label: "",
      isTrackedByMeActive: false,
      isCreatedByMeActive: false,
      fromDate: "",
      endDate: "",
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="stage-popup" onClick={(e) => e.stopPropagation()}>
      <div className="stage-popup-header">
        <div>
          <h3 className="stage-popup-title">Filter</h3>
          <div className="stage-popup-subtitle">
            Narrow {tenantLabel} by specific criteria
          </div>
        </div>
        <button className="stage-popup-close" onClick={onClose}>
          <img src={StagePopupIcon} alt="Close" />
        </button>
      </div>

      <div className="candidate-view-selection">
        <Button
          label="Tracked By"
          iconSrc={
            tempIsTrackedByMeActive
              ? isDarkMode
                ? createdDarkIcon
                : trackedSelectedIcon
              : isDarkMode
                ? createdNotSelectDark
                : trackedNotSelectedIcon
          }
          iconPosition="left"
          iconStyle={{ marginRight: "8px" }}
          event={handleTrackedByMeClick}
          className={`track-can-btn ${tempIsTrackedByMeActive ? "active" : ""}`}
        />
        <Button
          label="Created By"
          iconSrc={
            tempIsCreatedByMeActive
              ? isDarkMode
                ? createdDarkIcon
                : trackedSelectedIcon
              : isDarkMode
                ? createdNotSelectDark
                : trackedNotSelectedIcon
          }
          iconPosition="left"
          iconStyle={{ marginRight: "8px" }}
          event={handleCreatedByMeClick}
          className={`track-can-btn ${tempIsCreatedByMeActive ? "active" : ""}`}
        />
      </div>
      <div className="stage-popup-body">
        <div className="stage-filter-row">
          <div className="stage-filter-controls">
            <div
              className="client-date-filter-wrapper"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <div
                ref={fromRef}
                className="calendar-date-wrapper"
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid var(--border__color)",
                  width: "150px",
                  padding: "5px 10px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => openDatePicker("from", fromRef)}
              >
                <img
                  alt=""
                  src={isDarkMode ? darkCalendarIcon : calendarIcon}
                  style={{ width: "18px", marginRight: "8px" }}
                />
                <div
                  style={{ color: tempFromDate ? "inherit" : "#aaa" }}
                >
                  {tempFromDate
                    ? moment(tempFromDate).format("MMM D, YYYY")
                    : "From Date"}
                </div>
              </div>
              -
              <div
                ref={endRef}
                className="calendar-date-wrapper"
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid var(--border__color)",
                  width: "150px",
                  padding: "5px 10px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
                onClick={() => openDatePicker("end", endRef)}
              >
                <img
                  alt=""
                  src={isDarkMode ? darkCalendarIcon : calendarIcon}
                  style={{ width: "18px", marginRight: "8px" }}
                />
                <div
                  style={{ color: tempEndDate ? "inherit" : "#aaa" }}
                >
                  {tempEndDate
                    ? moment(tempEndDate).format("MMM D, YYYY")
                    : "End Date"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="stage-popup-body">
        {AdminAccess && (
          <div className="stage-filter-row">
            <div className="stage-filter-controls">
              <div className="filter-label">
                <img
                  src={isDarkMode ? candidateDarkIcon : candidateIcon}
                  alt="Users"
                  className="filter-label-icon"
                />
                <span>Users</span>
              </div>
              <div 
                className="stage-filter-value-wrapper"
                style={{ cursor: !isMemberFieldEnabled ? "not-allowed" : "default" }}
              >
                <DynamicAutocomplete
                  disabled={!isMemberFieldEnabled}
                  options={filteredUsers}
                  value={
                    users.find((u) => u.value === formik.values.users) || null
                  }
                  onChange={(value) =>
                    formik.setFieldValue("users", value?.value || "")
                  }
                  placeholder={"Select User"}
                  onInputChange={(_, value) => {
                    if (value) {
                      const filtered = users.filter((u) =>
                        u.label.toLowerCase().includes(value.toLowerCase()),
                      );
                      setFilteredUsers(filtered);
                    } else {
                      setFilteredUsers(users);
                    }
                  }}
                  onOpen={() => setFilteredUsers(users)}
                  noOptionsText={
                    filteredUsers.length === 0
                      ? "No users found..."
                      : "No options..."
                  }
                  loading={isUsersLoading}
                  sx={{
                    width: "100%",
                    ".MuiOutlinedInput-root": {
                      borderRadius: "4px",
                      height: "38px",
                      backgroundColor: "var(--body__background, #ffffff)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--border__color) !important",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6860ee",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6860ee",
                      },
                    },
                    ".MuiInputBase-input": {
                      color: "var(--header__color)",
                      padding: "0 12px !important",
                      fontSize: "14px",
                      fontFamily: "inherit",
                    },
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        backgroundColor: "var(--body__background)",
                        color: "var(--header__color)",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                        border: "1px solid var(--border__color)",
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div> */}

      <div className="stage-popup-actions">
        <Button
          event={handleClear}
          label="Clear"
          backgroundColor="#a90606"
          color="#ffffff"
          border="1px solid #a90606"
          hoverd={false}
        />
        <Button event={handleApply} label="Apply" />
      </div>
      {openPicker && pickerPosition.top !== null && (
        <CustomDatePickerModal
          initialDate={
            openPicker === "from"
              ? tempFromDate || new Date()
              : tempEndDate || new Date()
          }
          maxDate={new Date()}
          disablePast={false}
          onOk={(date) => {
            setPickerPosition({ top: null, left: null });
            if (openPicker === "from") {
              if (tempEndDate && moment(date).isAfter(moment(tempEndDate))) {
                Toast("error", "'From date' cannot be after 'End date'.");
                setOpenPicker(null);
                return;
              }
              setTempFromDate(date);
            } else {
              if (tempFromDate && moment(date).isBefore(moment(tempFromDate))) {
                Toast("error", "'End date' cannot be before 'From date'.");
                setOpenPicker(null);
                return;
              }
              setTempEndDate(date);
            }
            setOpenPicker(null);
          }}
          onClose={() => setOpenPicker(null)}
          top={pickerPosition.top}
          left={pickerPosition.left}
        />
      )}
    </div>
  );
}

export default ClientFilters;